<div class="main-container customer">
  <h1 class="form-title">
    <span class="icon"></span>
    Historique d'achats
  </h1>

  <ng-casto-common-customer-order-history [customerId]="this.customerId" [resume]="false" [context]="context"></ng-casto-common-customer-order-history>
</div>
